module.exports = __webpack_public_path__ + "static/media/1_elephant_dong.59ae5834.png";